export const etterforsking =
    [
        {
          "id": 1,
          "dato": "17. mars 2014",
          "hendelse": "Familien melder Reidar savnet hos politiet i Sauda etter halvannen måneds bekymring."
        },
        {
          "id": 2,
          "dato": "18. mars 2014",
          "hendelse": "Lokalt politi ber Interpol etterlyse Reidar. Varselet sendes ut internasjonalt neste dag."
        },
        {
          "id": 3,
          "dato": "19. mars 2014",
          "hendelse": "Reidar etterlyst gjennom Interpol på “Yellow Notice”. Kopi til Brasils ambassade i Norge."
        },
        {
          "id": 4,
          "dato": "24. mars 2014",
          "hendelse": "Interpol Norge sender detaljer om etterlysningen til kollegene i Brasil og norsk ambassade i Brasil."
        },
        {
          "id": 5,
          "dato": "8. April 2014",
          "hendelse": "Paula til politi i Brasil: Vet ikke hvor Reidar er, men han har det bra og vil ikke ha kontakt med Norge."
        },
        {
          "id": 6,
          "dato": "29. mai 2014",
          "hendelse": "Interpol Brasil: Eks-kjæresten sier hun ikke har sett Reidar siden mars, men at venner har sett ham."
        },
        {
          "id": 7,
          "dato": "9. juli 2014",
          "hendelse": "Felles-nordisk politisambandskvinne i Sør-Amerika mener norsk politi bør vurdere avhør av Paula."
        },
        {
          "id": 8,
          "dato": "9. juli 2014",
          "hendelse": "Legger ved dokument som viser hvordan man skal fylle ut en rettsbegjæring til Brasil, videresendes politiet i Sauda."
        },
        {
          "id": 9,
          "dato": "27. August 2014",
          "hendelse": "Interpol Norge purrer på Interpol Brasil."
        },
        {
          "id": 10,
          "dato": "28. August 2014",
          "hendelse": "Interpol Norge: Politiet i Sauda er klare “til å starte prosessen med rettsanmodning vedr avhør.”"
        },
        {
          "id": 11,
          "dato": "28. August 2014",
          "hendelse": "Interpol Norge ber om bistand til undersøkelser for å avdekke om Reidar hadde bankkonti i Brasil."
        },
        {
          "id": 12,
          "dato": "28. August 2014",
          "hendelse": "Nordisk politikontakt i Sør-Amerika vil bistå. Spør norsk politi om det pågår etterforskning i Brasil."
        },
        {
          "id": 13,
          "dato": "10. September 2014",
          "hendelse": "Siste kontakt norsk og brasiliansk Interpol: Brasiliansk politi har etterlyst og lett uten resultat."
        },
        {
          "id": 14,
          "dato": "28. November 2014",
          "hendelse": "Nordisk politisambandskvinne i Sør-Amerika: Ikke hørt fra norsk politi “sedan september”."
        },
        {
          "id": 15,
          "dato": "12. desember 2014",
          "hendelse": "Politiet i Sauda: “mye som “skurrer” i denne saken”."
        },
        {
          "id": 16,
          "dato": "16. januar 2015",
          "hendelse": "Politiinspektør skriver utkast til rettsanmodning for å få brasiliansk politi til å avhøre Paula."
        },
        {
          "id": 17,
          "dato": "19. januar 2015",
          "hendelse": "Anmodningen sendes videre til statsadvokaten i Rogaland."
        },
        {
          "id": 18,
          "dato": "4. februar 2015",
          "hendelse": "Statsadvokat returnerer anmodning til politiet, ber om flere opplysninger og hjemler."
        },
        {
          "id": 19,
          "dato": "11. juni 2015",
          "hendelse": "Politiet sender statsadvokaten ny rettsanmodning til Brasil om avhør av Paula."
        },
        {
          "id": 20,
          "dato": "22. juni 2015",
          "hendelse": "Statsadvokaten returnerer for andre gang henvendelsen: “må utformes på annen måte…”"
        },
        {
          "id": 21,
          "dato": "25. juni 2015",
          "hendelse": "Politiet ber om nærmere presisering av hva som ligger i “annen måte”."
        },
        {
          "id": 22,
          "dato": "12. August 2015",
          "hendelse": "Statsadvokaten returnerer henvendelsen og viser til “samtaler med politiinspektør”."
        },
        {
          "id": 23,
          "dato": "12. August 2015",
          "hendelse": "Ser ikke ut til å ha funnet sted ytterligere etterforskning."
        },
        {
          "id": 24,
          "dato": "9. mars 2016",
          "hendelse": "Norsk politi henlegger Reidar Sandanger-saken med henvisning til kode 016 - “utenfor straffesak”."
        },
        {
          "id": 25,
          "dato": "26. mai 2017",
          "hendelse": "Oslo Byfogdembete avsier kjennelse: Reidar Sandanger er død - omtaler en rekke forhold som mistenkelige."
        },
        {
          "id": 26,
          "dato": "22. November 2017",
          "hendelse": "Paula hos brasiliansk politi: Har ikke sett Reidar siden 30. mars 2014. Saken blir henlagt."
        }
      ]

